import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';

export const summaryHeaderQuestionButtons = [
  BudgetQuestionCodes.Q13,
  BudgetQuestionCodes.Q14,
  BudgetQuestionCodes.Q21,
  BudgetQuestionCodes.Q27,
  BudgetQuestionCodes.Q29,
  BudgetQuestionCodes.Q30,
  BudgetQuestionCodes.Q10,
  BudgetQuestionCodes.Q15,
  BudgetQuestionCodes.Q17,
  BudgetQuestionCodes.Q19,
  BudgetQuestionCodes.Q21,
  BudgetQuestionCodes.Q24,
];

export const summaryHeaderFixedQuestionButtons = [
  BudgetQuestionCodes.Q15,
  BudgetQuestionCodes.Q17,
  BudgetQuestionCodes.Q19,
  BudgetQuestionCodes.Q21,
  BudgetQuestionCodes.Q24,
];
